import { render, staticRenderFns } from "./addMedia.vue?vue&type=template&id=80ec56c0"
import script from "./addMedia.vue?vue&type=script&lang=js"
export * from "./addMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports